export default __webpack_public_path__ + "static/media/thumbnail2.20eb5794.jpg";